var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTranslation } from 'react-i18next';
// @mui
import { Table, TableRow, TableHead, TableBody, TableCell, TableContainer, } from '@mui/material';
import CollapsibleTableRow from './CollapsibleTableRow';
export default function CollapsibleTable(_a) {
    var columns = _a.columns, rows = _a.rows, isOrderColumnShown = _a.isOrderColumnShown, isSampleOrderColumnShown = _a.isSampleOrderColumnShown, renderFarmWithLink = _a.renderFarmWithLink, renderStock = _a.renderStock, renderComment = _a.renderComment, renderOrderTypeIcon = _a.renderOrderTypeIcon, renderFobPrice = _a.renderFobPrice, renderSampleOrder = _a.renderSampleOrder, renderOrderAmount = _a.renderOrderAmount;
    var t = useTranslation().t;
    var customColumns = columns.map(function (column) { return (__assign({ title: t("params.".concat(String(column.field)), '') ||
            t("params.".concat(String(column.field))) }, column)); });
    return (React.createElement(TableContainer, null,
        React.createElement(Table, { sx: {
                backgroundColor: function (theme) { return theme.customPalette.background.neutral; },
            } },
            React.createElement(TableHead, null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { sx: { width: '48px', minWidth: '48px' } }),
                    customColumns.map(function (column, index) { return (React.createElement(TableCell, { key: index, align: column.align, sx: {
                            width: column.width,
                            minWidth: column.width ? '100px' : null,
                        } }, column.title)); }))),
            React.createElement(TableBody, { sx: {
                    backgroundColor: function (theme) { return theme.customPalette.background.paper; },
                } }, rows.map(function (row) { return (React.createElement(CollapsibleTableRow, { key: row.id, row: row, isOrderColumnShown: isOrderColumnShown, isSampleOrderColumnShown: isSampleOrderColumnShown, renderFarmWithLink: renderFarmWithLink, renderStock: renderStock, renderComment: renderComment, renderOrderTypeIcon: renderOrderTypeIcon, renderFobPrice: renderFobPrice, renderOrderAmount: renderOrderAmount, renderSampleOrder: renderSampleOrder })); })))));
}
